import React from 'react';
import './Footer.css';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaYoutube, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column">
              <div className="footer-logo">
                <img src="/website/grandislogo_white.png" alt="Grandis Solutions" className="footer-logo-image" />
                <div className="logo-text">
                  <span className="logo-main">Grandis</span>
                  <span className="logo-sub">Business Solutions</span>
                </div>
              </div>
              <p className="footer-description">
                Leading healthcare software provider delivering innovative solutions for 
                hospitals and healthcare facilities across the globe.
              </p>
              <div className="footer-social">
                <a href="#facebook" aria-label="Facebook"><FaFacebookF /></a>
                <a href="#twitter" aria-label="Twitter"><FaTwitter /></a>
                <a href="#linkedin" aria-label="LinkedIn"><FaLinkedinIn /></a>
                <a href="#instagram" aria-label="Instagram"><FaInstagram /></a>
                <a href="#youtube" aria-label="YouTube"><FaYoutube /></a>
              </div>
            </div>

            <div className="footer-column">
              <h4>Products</h4>
              <ul>
                <li><a href="#products">Hospital Management System</a></li>
                <li><a href="#products">Queue Management</a></li>
                <li><a href="#products">Feedback System</a></li>
                <li><a href="#products">HR Software</a></li>
                <li><a href="#products">Operations Management</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Company</h4>
              <ul>
                <li><a href="#about">About Us</a></li>
                <li><a href="#features">Why Choose Us</a></li>
                <li><a href="#contact">Careers</a></li>
                <li><a href="#contact">Blog</a></li>
                <li><a href="#contact">Support</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Contact Us</h4>
              <ul className="footer-contact">
                <li>
                  <FaPhone />
                  <div>
                    <a href="tel:+918078930388">+91 8078930388</a>
                    <a href="tel:+919947346577">+91 9947346577</a>
                  </div>
                </li>
                <li>
                  <FaEnvelope />
                  <div>
                    <a href="mailto:sales@grandissolutions.in">sales@grandissolutions.in</a>
                    <a href="mailto:info@grandissolutions.in">info@grandissolutions.in</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Grandis Business Solutions Pvt Ltd. All rights reserved.</p>
            <div className="footer-links">
              <a href="#privacy">Privacy Policy</a>
              <span>•</span>
              <a href="#terms">Terms of Service</a>
              <span>•</span>
              <a href="#sitemap">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
